import styled from "styled-components";
export { FormSection, FormRow, FormField, FormLabel, FormInput, FormSelect, ToggleRow, ToggleRowLabel } from "@/screen/Identities/Styles/IdentityFormStyles";
export { SearchableSelectWrapper } from "@/screen/Identities/IdentityFiscalInputs/Styles/IdentityFiscalInputsStyles";

export const AddressSectionSubheading = styled.h3`
    margin-top: 20px;
    margin-bottom: 12px;
`;